/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CarePrincipalAccess,
    CarePrincipalAccessFromJSON,
    CarePrincipalAccessToJSON,
    CarePrincipalAccessDTO,
    CarePrincipalAccessDTOFromJSON,
    CarePrincipalAccessDTOToJSON,
    CarePrincipalSettings,
    CarePrincipalSettingsFromJSON,
    CarePrincipalSettingsToJSON,
    CarePrincipalSettingsEntity,
    CarePrincipalSettingsEntityFromJSON,
    CarePrincipalSettingsEntityToJSON,
    CareUnitSettings,
    CareUnitSettingsFromJSON,
    CareUnitSettingsToJSON,
    CareUnitSettingsDTO,
    CareUnitSettingsDTOFromJSON,
    CareUnitSettingsDTOToJSON,
    ContractEntity,
    ContractEntityFromJSON,
    ContractEntityToJSON,
    PuServiceInfo,
    PuServiceInfoFromJSON,
    PuServiceInfoToJSON,
    UpdateCarePrincipalSettingsDTO,
    UpdateCarePrincipalSettingsDTOFromJSON,
    UpdateCarePrincipalSettingsDTOToJSON,
    UpdateJobConfigurationsDTO,
    UpdateJobConfigurationsDTOFromJSON,
    UpdateJobConfigurationsDTOToJSON,
} from '../models';

export interface AddCarePrincipalAccessRequest {
    carePrincipalId: string;
    idType: string;
    carePrincipalAccessDTO: CarePrincipalAccessDTO;
}

export interface AddCareUnitSettingsRequest {
    careUnitId: string;
    careUnitSettingsDTO: CareUnitSettingsDTO;
}

export interface DeleteCarePrincipalAccessRequest {
    carePrincipalId: string;
    careAccessId: string;
}

export interface DeleteCareUnitSettingsRequest {
    careUnitId: string;
}

export interface GetAllowedContractsRequest {
    carePrincipalId: string;
}

export interface GetCarePrincipalAccessRequest {
    carePrincipalId: string;
}

export interface GetCarePrincipalSettingsRequest {
    carePrincipalId: string;
}

export interface GetCareUnitSettingsRequest {
    careUnitId: string;
}

export interface GetJobsConfigurationForCarePrincipalRequest {
    carePrincipalId: string;
}

export interface SaveSettingsFileRequest {
    file?: Blob;
}

export interface UpdateAllowedContractsRequest {
    carePrincipalId: string;
    requestBody: Array<string>;
}

export interface UpdateCarePrincipalAccessRequest {
    carePrincipalId: string;
    careAccessId: string;
    carePrincipalAccessDTO: CarePrincipalAccessDTO;
}

export interface UpdateCarePrincipalSettingsRequest {
    carePrincipalId: string;
    updateCarePrincipalSettingsDTO: UpdateCarePrincipalSettingsDTO;
}

export interface UpdateJobsConfigurationsByCardTypeRequest {
    carePrincipalId: string;
    updateJobConfigurationsDTO: UpdateJobConfigurationsDTO;
}

/**
 * 
 */
export class CarePrincipalAdministrationApi extends runtime.BaseAPI {

    /**
     */
    async addCarePrincipalAccessRaw(requestParameters: AddCarePrincipalAccessRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling addCarePrincipalAccess.');
        }

        if (requestParameters.idType === null || requestParameters.idType === undefined) {
            throw new runtime.RequiredError('idType','Required parameter requestParameters.idType was null or undefined when calling addCarePrincipalAccess.');
        }

        if (requestParameters.carePrincipalAccessDTO === null || requestParameters.carePrincipalAccessDTO === undefined) {
            throw new runtime.RequiredError('carePrincipalAccessDTO','Required parameter requestParameters.carePrincipalAccessDTO was null or undefined when calling addCarePrincipalAccess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/authorization/{idType}`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"idType"}}`, encodeURIComponent(String(requestParameters.idType))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CarePrincipalAccessDTOToJSON(requestParameters.carePrincipalAccessDTO),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async addCarePrincipalAccess(carePrincipalId: string, idType: string, carePrincipalAccessDTO: CarePrincipalAccessDTO, initOverrides?: RequestInit): Promise<string> {
        const response = await this.addCarePrincipalAccessRaw({ carePrincipalId: carePrincipalId, idType: idType, carePrincipalAccessDTO: carePrincipalAccessDTO }, initOverrides);
        return await response.value();
    }

    /**
     */
    async addCareUnitSettingsRaw(requestParameters: AddCareUnitSettingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.careUnitId === null || requestParameters.careUnitId === undefined) {
            throw new runtime.RequiredError('careUnitId','Required parameter requestParameters.careUnitId was null or undefined when calling addCareUnitSettings.');
        }

        if (requestParameters.careUnitSettingsDTO === null || requestParameters.careUnitSettingsDTO === undefined) {
            throw new runtime.RequiredError('careUnitSettingsDTO','Required parameter requestParameters.careUnitSettingsDTO was null or undefined when calling addCareUnitSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/administration/careunitsettings/{careUnitId}`.replace(`{${"careUnitId"}}`, encodeURIComponent(String(requestParameters.careUnitId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CareUnitSettingsDTOToJSON(requestParameters.careUnitSettingsDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addCareUnitSettings(careUnitId: string, careUnitSettingsDTO: CareUnitSettingsDTO, initOverrides?: RequestInit): Promise<void> {
        await this.addCareUnitSettingsRaw({ careUnitId: careUnitId, careUnitSettingsDTO: careUnitSettingsDTO }, initOverrides);
    }

    /**
     */
    async deleteCarePrincipalAccessRaw(requestParameters: DeleteCarePrincipalAccessRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling deleteCarePrincipalAccess.');
        }

        if (requestParameters.careAccessId === null || requestParameters.careAccessId === undefined) {
            throw new runtime.RequiredError('careAccessId','Required parameter requestParameters.careAccessId was null or undefined when calling deleteCarePrincipalAccess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/authorization/{careAccessId}`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"careAccessId"}}`, encodeURIComponent(String(requestParameters.careAccessId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async deleteCarePrincipalAccess(carePrincipalId: string, careAccessId: string, initOverrides?: RequestInit): Promise<string> {
        const response = await this.deleteCarePrincipalAccessRaw({ carePrincipalId: carePrincipalId, careAccessId: careAccessId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteCareUnitSettingsRaw(requestParameters: DeleteCareUnitSettingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.careUnitId === null || requestParameters.careUnitId === undefined) {
            throw new runtime.RequiredError('careUnitId','Required parameter requestParameters.careUnitId was null or undefined when calling deleteCareUnitSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/administration/careunitsettings/{careUnitId}`.replace(`{${"careUnitId"}}`, encodeURIComponent(String(requestParameters.careUnitId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCareUnitSettings(careUnitId: string, initOverrides?: RequestInit): Promise<void> {
        await this.deleteCareUnitSettingsRaw({ careUnitId: careUnitId }, initOverrides);
    }

    /**
     */
    async getAllAllowedContractsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ContractEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/allowed-contracts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContractEntityFromJSON));
    }

    /**
     */
    async getAllAllowedContracts(initOverrides?: RequestInit): Promise<Array<ContractEntity>> {
        const response = await this.getAllAllowedContractsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllCarePrincipalAccessRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CarePrincipalAccess>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/authorized-entities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CarePrincipalAccessFromJSON));
    }

    /**
     */
    async getAllCarePrincipalAccess(initOverrides?: RequestInit): Promise<Array<CarePrincipalAccess>> {
        const response = await this.getAllCarePrincipalAccessRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllJobsConfigurationsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CarePrincipalSettingsEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/jobs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CarePrincipalSettingsEntityFromJSON));
    }

    /**
     */
    async getAllJobsConfigurations(initOverrides?: RequestInit): Promise<Array<CarePrincipalSettingsEntity>> {
        const response = await this.getAllJobsConfigurationsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllSettingsFilesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/settings/files`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getAllSettingsFiles(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.getAllSettingsFilesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllowedContractsRaw(requestParameters: GetAllowedContractsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getAllowedContracts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/allowed-contracts`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getAllowedContracts(carePrincipalId: string, initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.getAllowedContractsRaw({ carePrincipalId: carePrincipalId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCarePrincipalAccessRaw(requestParameters: GetCarePrincipalAccessRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CarePrincipalAccess>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getCarePrincipalAccess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/authorized-entities`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CarePrincipalAccessFromJSON(jsonValue));
    }

    /**
     */
    async getCarePrincipalAccess(carePrincipalId: string, initOverrides?: RequestInit): Promise<CarePrincipalAccess> {
        const response = await this.getCarePrincipalAccessRaw({ carePrincipalId: carePrincipalId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCarePrincipalSettingsRaw(requestParameters: GetCarePrincipalSettingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CarePrincipalSettings>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getCarePrincipalSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/settings`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CarePrincipalSettingsFromJSON(jsonValue));
    }

    /**
     */
    async getCarePrincipalSettings(carePrincipalId: string, initOverrides?: RequestInit): Promise<CarePrincipalSettings> {
        const response = await this.getCarePrincipalSettingsRaw({ carePrincipalId: carePrincipalId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCareUnitSettingsRaw(requestParameters: GetCareUnitSettingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CareUnitSettings>> {
        if (requestParameters.careUnitId === null || requestParameters.careUnitId === undefined) {
            throw new runtime.RequiredError('careUnitId','Required parameter requestParameters.careUnitId was null or undefined when calling getCareUnitSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/administration/careunitsettings/{careUnitId}`.replace(`{${"careUnitId"}}`, encodeURIComponent(String(requestParameters.careUnitId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CareUnitSettingsFromJSON(jsonValue));
    }

    /**
     */
    async getCareUnitSettings(careUnitId: string, initOverrides?: RequestInit): Promise<CareUnitSettings> {
        const response = await this.getCareUnitSettingsRaw({ careUnitId: careUnitId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getJobsConfigurationForCarePrincipalRaw(requestParameters: GetJobsConfigurationForCarePrincipalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CarePrincipalSettingsEntity>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getJobsConfigurationForCarePrincipal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/jobs`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CarePrincipalSettingsEntityFromJSON(jsonValue));
    }

    /**
     */
    async getJobsConfigurationForCarePrincipal(carePrincipalId: string, initOverrides?: RequestInit): Promise<CarePrincipalSettingsEntity> {
        const response = await this.getJobsConfigurationForCarePrincipalRaw({ carePrincipalId: carePrincipalId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPuServicesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<PuServiceInfo>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/pu-services`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PuServiceInfoFromJSON));
    }

    /**
     */
    async getPuServices(initOverrides?: RequestInit): Promise<Array<PuServiceInfo>> {
        const response = await this.getPuServicesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async saveSettingsFileRaw(requestParameters: SaveSettingsFileRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/administration/file`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async saveSettingsFile(file?: Blob, initOverrides?: RequestInit): Promise<void> {
        await this.saveSettingsFileRaw({ file: file }, initOverrides);
    }

    /**
     */
    async updateAllowedContractsRaw(requestParameters: UpdateAllowedContractsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling updateAllowedContracts.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling updateAllowedContracts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/allowed-contracts`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAllowedContracts(carePrincipalId: string, requestBody: Array<string>, initOverrides?: RequestInit): Promise<void> {
        await this.updateAllowedContractsRaw({ carePrincipalId: carePrincipalId, requestBody: requestBody }, initOverrides);
    }

    /**
     */
    async updateCarePrincipalAccessRaw(requestParameters: UpdateCarePrincipalAccessRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling updateCarePrincipalAccess.');
        }

        if (requestParameters.careAccessId === null || requestParameters.careAccessId === undefined) {
            throw new runtime.RequiredError('careAccessId','Required parameter requestParameters.careAccessId was null or undefined when calling updateCarePrincipalAccess.');
        }

        if (requestParameters.carePrincipalAccessDTO === null || requestParameters.carePrincipalAccessDTO === undefined) {
            throw new runtime.RequiredError('carePrincipalAccessDTO','Required parameter requestParameters.carePrincipalAccessDTO was null or undefined when calling updateCarePrincipalAccess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/authorization/{careAccessId}`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"careAccessId"}}`, encodeURIComponent(String(requestParameters.careAccessId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CarePrincipalAccessDTOToJSON(requestParameters.carePrincipalAccessDTO),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async updateCarePrincipalAccess(carePrincipalId: string, careAccessId: string, carePrincipalAccessDTO: CarePrincipalAccessDTO, initOverrides?: RequestInit): Promise<string> {
        const response = await this.updateCarePrincipalAccessRaw({ carePrincipalId: carePrincipalId, careAccessId: careAccessId, carePrincipalAccessDTO: carePrincipalAccessDTO }, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCarePrincipalSettingsRaw(requestParameters: UpdateCarePrincipalSettingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling updateCarePrincipalSettings.');
        }

        if (requestParameters.updateCarePrincipalSettingsDTO === null || requestParameters.updateCarePrincipalSettingsDTO === undefined) {
            throw new runtime.RequiredError('updateCarePrincipalSettingsDTO','Required parameter requestParameters.updateCarePrincipalSettingsDTO was null or undefined when calling updateCarePrincipalSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/administration/settings/{carePrincipalId}`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCarePrincipalSettingsDTOToJSON(requestParameters.updateCarePrincipalSettingsDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateCarePrincipalSettings(carePrincipalId: string, updateCarePrincipalSettingsDTO: UpdateCarePrincipalSettingsDTO, initOverrides?: RequestInit): Promise<void> {
        await this.updateCarePrincipalSettingsRaw({ carePrincipalId: carePrincipalId, updateCarePrincipalSettingsDTO: updateCarePrincipalSettingsDTO }, initOverrides);
    }

    /**
     */
    async updateJobsConfigurationsByCardTypeRaw(requestParameters: UpdateJobsConfigurationsByCardTypeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling updateJobsConfigurationsByCardType.');
        }

        if (requestParameters.updateJobConfigurationsDTO === null || requestParameters.updateJobConfigurationsDTO === undefined) {
            throw new runtime.RequiredError('updateJobConfigurationsDTO','Required parameter requestParameters.updateJobConfigurationsDTO was null or undefined when calling updateJobsConfigurationsByCardType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/jobs`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateJobConfigurationsDTOToJSON(requestParameters.updateJobConfigurationsDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateJobsConfigurationsByCardType(carePrincipalId: string, updateJobConfigurationsDTO: UpdateJobConfigurationsDTO, initOverrides?: RequestInit): Promise<void> {
        await this.updateJobsConfigurationsByCardTypeRaw({ carePrincipalId: carePrincipalId, updateJobConfigurationsDTO: updateJobConfigurationsDTO }, initOverrides);
    }

}
